 
 
  export const Persona = [
    { value: 101, label: 'Admin' },
    { value: 102, label: 'Field' },
    { value: 103, label: 'Headquarter' },  
    { value: 104, label: 'Dealer' },
    { value: 105, label: 'Service' },
    { value: 106, label: 'Parts' },

  ];

  export const DealerRole1 = [
    { value: "Admin", label: 'Admin' },
    { value: "AKP", label: 'AKP' },
    { value: "ANAND", label: 'ANAND' },
    { value: "Atlas", label: 'Atlas' },
    { value: "Abutani", label: 'Abutani' },
    { value: "Autobahn", label: 'Autobahn' },
    { value: "Autobahn MH", label: 'Autobahn MH' },
    { value: "Bebbco", label: 'Bebbco' },
    { value: "Dhingra", label: 'Dhingra' },
    { value: "DICV", label: 'DICV' },
    { value: "DRIVE", label: 'DRIVE' },
    { value: "Gautam", label: 'Gautam' },
    { value: "Globe", label: 'Globe' },
    { value: "GMMCO", label: 'GMMCO' },
    { value: "GMMCO on road", label: 'GMMCO on road' },
    { value: "Himatsingka", label: 'Himatsingka' },
    { value: "Innovative", label: 'Innovative' },
    { value: "Jayaraj", label: 'Jayaraj' },
    { value: "JS", label: 'JS' },
    { value: "JK", label: 'JK' },
    { value: "Kamal Jaipur", label: 'Kamal Jaipur' },
    { value: "Kamal Udaipur", label: 'Kamal Udaipur' },
    { value: "Kasliwal", label: 'Kasliwal' },
    { value: "Kataria", label: 'Kataria' },
    { value: "Kun", label: 'Kun' },
    { value: "Maaambika", label: 'Maaambika' },
    { value: "Mamta", label: 'Mamta' },
    { value: "Marwar", label: 'Marwar' },
    { value: "Pal", label: 'Pal' },
    { value: "PMG", label: 'PMG' },
    { value: "PPS", label: 'PPS' },
    { value: "PPS MP", label: 'PPS MP' },
    { value: "Prabal", label: 'Prabal' }
  ];

  export const DealerRole = [
    { value: "ABUTANI", label: 'ABUTANI' },
    { value: "Admin", label: 'Admin' },
    { value: "AKP", label: 'AKP' },
    { value: "ANAND", label: 'ANAND' },
    { value: "ATLAS", label: 'ATLAS' },
    { value: "AUTOBAHN", label: 'AUTOBAHN' },
    { value: "AUTOBAHN MH", label: 'AUTOBAHN MH' },
    { value: "AUTOBAHN MUM", label: 'AUTOBAHN MUM' },
    { value: "AUTOBAHN UP", label: 'AUTOBAHN UP' },
    { value: "AUTOBAHN PUNE", label: 'AUTOBAHN PUNE' },
    { value: "AUTOBAHN KL", label: 'AUTOBAHN KL' },
    {value:  "GAINWELL WB",label:"GAINWELL WB"},
    {value:  "IIMS WB",label:"IIMS WB"},

    { value: "BEBBCO", label: 'BEBBCO' },
    { value: "DHINGRA", label: 'DHINGRA' },
    { value: "DICV", label: 'DICV' },
    { value: "DRIVE", label: 'DRIVE' },
    { value: "GAUTAM", label: 'GAUTAM' },
    { value: "GLOBE", label: 'GLOBE' },
    { value: "GMMCO", label: 'GMMCO' },
    { value: "GMMCO on road", label: 'GMMCO on road' },
    { value: "HIMATSINGKA", label: 'HIMATSINGKA' },
    { value: "INNOVATIVE", label: 'INNOVATIVE' },
    { value: "JAYARAJ", label: 'JAYARAJ' },
    { value: "JJS", label: 'JJS' },
    { value: "JK", label: 'JK' },
    { value: "KAMAL JAIPUR", label: 'KAMAL JAIPUR' },
    { value: "KAMAL UDAIPUR", label: 'KAMAL UDAIPUR' },
    { value: "KASLIWAL", label: 'KASLIWAL' },
    { value: "KATARIA", label: 'KATARIA' },
    { value: "KUN", label: 'KUN' },
    { value: "MAAAMBIKA", label: 'MAAAMBIKA' },
    { value: "MAMTA", label: 'MAMTA' },
    { value: "MARWAR", label: 'MARWAR' },
    { value: "PAL", label: 'PAL' },
    { value: "PMG", label: 'PMG' },
    { value: "PPS", label: 'PPS' },
    { value: "PPS MP", label: 'PPS MP' },
    { value: "PPS AS", label: 'PPS AS' },
    { value: "PPS UP", label: 'PPS UP' },
    { value: "PPS JK", label: 'PPS JK' },
    { value: "PPS OD", label: 'PPS OD' },
    { value: "PRABAL", label: 'PRABAL' },
    { value: "PRABAL MH", label: 'PRABAL MH' },
    { value: "PRABAL PB", label: 'PRABAL PB' },
    { value: "PRABAL TN", label: 'PRABAL TN' },
    { value: "RAJENDRA", label: 'RAJENDRA' },
    { value: "RNS", label: 'RNS' },
    { value: "SATYA", label: 'SATYA' },
    { value: "SCINTILATION", label: 'SCINTILATION' },
    { value: "SOCIETY", label: 'SOCIETY' },
    { value: "SPIRITED", label: 'SPIRITED' },
    { value: "SPIRITED MH", label: 'SPIRITED MH' },
    { value: "SRI HARSHA", label: 'SRI HARSHA' },
    { value: "TOPSPARES", label: 'TOPSPARES' },
    { value: "TRIDENT", label: 'TRIDENT' },
    { value: "VARUN", label: 'VARUN' },
    { value: "WASAN", label: 'WASAN' },

    
    // { value: "AJSG", label: 'AJSG' },

  ];